import { useSortBy } from 'react-instantsearch';
import { useFrame } from '~/shared/utils';
import { algoliaSortOptions as defaultOptions } from '~/services/instantsearch';

export const VirtualSortBy: React.FC = () => {
    const { data: frameData } = useFrame();

    // TODO(IMC-2274): Remove fallback hardcoded options once configuration is available in all environments.
    useSortBy({
        items: frameData.productSettings?.sortingMethods?.length
            ? frameData.productSettings.sortingMethods
            : defaultOptions,
    });

    return null;
};
